<app-nav-bar></app-nav-bar>

<div class="container mt-2 ">


<div class="card shadow-sm">
<router-outlet></router-outlet>
</div>
</div>
